<div class="px-1 py-0 bg-white/30 rounded-lg" [class.moving]="isMoving" >
  <ng-container *ngIf="isOnline; else offlineTemplate">
    <div class="flex items-center justify-between">
      <span
        class="text-sm font-medium text-green-600 opacity-100 transition-opacity ease-in-out delay-300 duration-2000">
        {{'SystemAdmin.Components.TagOnlineIndicator.Online' | translate}}</span>

      <ng-container *ngIf="isMoving; else standingTemplate">
        <fa-icon [icon]="['fas', 'shoe-prints']" [rotate]="270"  class="shoe-step-animation text-slate-400 ml-1"></fa-icon>
      </ng-container>
      <ng-template #standingTemplate>
        <fa-icon [icon]="['fas', 'circle-check']" class="text-green-500 ml-1"></fa-icon>
      </ng-template>

    </div>
  </ng-container>

  <ng-template #offlineTemplate>
    <div class="flex items-center justify-between">
      <span
        class="text-sm font-medium text-red-600 opacity-100 transition-opacity ease-in-out delay-300 duration-2000">{{'SystemAdmin.Components.TagOnlineIndicator.Offline'
        | translate}}</span>
      <fa-icon [icon]="['fas', 'circle-xmark']" class="text-red-500 ml-1"></fa-icon>
    </div>
  </ng-template>
</div>